<template>
    <div class="page-content__content" v-html ="html" />
 </template>
 
 <script>
 
 /**
  * Vue: Recommended products (blade-recommended)
  * -----------------------------------------------------------------------------
  * Cross sell module to recommend products.
  * - Limited interactivity section.
  *
  * @param {String} liquid.sectionId - Section's Liquid ID.
  *
  */
 


 export default {
   name: 'PageContent',
 
   props: {
     url: {
       type: String,
       default: null,
     },
     html:
     {
       type: String,
       default: null,
     },
   },
 
   data() {
     return {
       }
   },
 
   mounted() {
    if(this.url){
  
    const script = document.createElement('script');
    script.src = this.url;
    script.async = true;
    document.head.appendChild(script);
   }
   },
 
  
 }
 </script>
 
 <style lang="scss">
 @import './page-content';
 </style>
 